// Enumerations
import { KycStatesEnumeration } from '../enumerations/kyc-states.enumeration';
// Resolvers
import { getKYCFlowDataResolver } from 'containers/kyc/resolvers/kyc.resolver';
// Translations
import { FETCHING_DESCRIPTION, FETCHING_TITLE } from 'containers/kyc/translations/kyc.translations';

const KYC_LAYOUT_COMPONENT_PROPS = {
    externalFetchingConfiguration: {
      description: FETCHING_DESCRIPTION,
      title: FETCHING_TITLE,
    },
    fetchResolver: getKYCFlowDataResolver,
  },
  KYC_LAYOUT_ASSET_COMPONENT_PROPS = {
    [KycStatesEnumeration.LANDING]: 'illustration_L3_tutorial_document-tips-OK-default',
  };

export { KYC_LAYOUT_ASSET_COMPONENT_PROPS, KYC_LAYOUT_COMPONENT_PROPS };
